import { LOCAL_STORAGE_KEY, SESSION_STORAGE_KEY, STORAGE_LOCATION } from 'constants/browserCache';

import { getStorageItem } from 'utils/browserCache';
import { StorageLocationType } from 'utils/browserCache/types';
import { JsonEditor } from '../JsonEditor';

export const BrowserStorageDebug = ({
  storageLocation,
}: {
  storageLocation: StorageLocationType;
}) => {
  return (
    <>
      {Object.values(
        storageLocation === STORAGE_LOCATION.LOCAL_STORAGE
          ? LOCAL_STORAGE_KEY
          : SESSION_STORAGE_KEY,
      )
        .map((key) => {
          const data = getStorageItem(storageLocation, key);
          if (!data) return null;

          return <JsonEditor key={key} rootName={key} data={data} />;
        })
        .filter(Boolean)}
    </>
  );
};
